import type { RouteRecordRaw } from 'vue-router'

import useAuthUser from '@/composables/useAuthUser'

/**
 * Solicitud de crédito del cliente. La revisión y la decisión las hace la
 * agencia en booking-internal; aquí sólo vive el lado del cliente.
 *
 * El gate duro está en el backend (ability `manage-credit-request`, only_owned);
 * esto sólo evita entrar sin empresa, igual que el resto de los módulos.
 */
export default {
	path: '/credit-requests',
	name: 'creditRequests.index',
	component: () =>
		import('@/modules/creditRequests/pages/CreditRequestsPage.vue'),
	beforeEnter: (_to, _from, next) => {
		const { user } = useAuthUser()

		if (user.value?.internal || !user.value?.companyId) {
			return next({ path: '/error/not-found' })
		}

		return next()
	},
} as RouteRecordRaw
